import {useTranslation} from "react-i18next";

/**
 * @param useEnglishNotation - if true, the number will be formatted in English notation (e.g. 1.2k). In other languages (such as German) the number 1200 will not be formatted as 1.2k, hence the default
 */
const useSocialNumberFormat = (useEnglishNotation: boolean = true, useCompactNotation: boolean = true) => {
  const {i18n} = useTranslation("common");
  const formatter = Intl.NumberFormat(useEnglishNotation ? "en" : i18n.language, {
    notation: useCompactNotation ? "compact" : undefined,
  });
  const format = (value: number | null | undefined) => formatter.format(value || 0);

  return format;
};

const useFormatPercentageRate = () => {
  const formatNumber = useSocialNumberFormat();

  const format = (engagement: number | null) => {
    if (engagement === null) return "0%";

    const rate = 100 * engagement;

    return rate < 1 ? "1%" : `${formatNumber(rate)}%`;
  };

  return format;
};

export {useFormatPercentageRate, useSocialNumberFormat};
